import { Form, Message } from 'semantic-ui-react';
import PasswordRevealerInput from 'components/PasswordRevealerInput/PasswordRevealerInput';
import React from 'react';
import useInput from 'hooks/useInput';

export default function LoginForm({
  loading,
  error,
  submitHandler = () => {},
}) {
  const [email, setEmail] = useInput();
  const [password, setPassword] = useInput();

  return (
    <Form onSubmit={(event, data) => submitHandler(email, password)}>
      {error && (
        <Message negative style={{ marginBottom: 40 }}>
          {error}
        </Message>
      )}
      <Form.Input
        required
        value={email}
        onChange={setEmail}
        placeholder="E-mail"
        className="email"
        label="Usuario"
      />
      <PasswordRevealerInput
        required
        value={password}
        onChange={setPassword}
        placeholder="Contraseña"
        className="password"
        label="Contraseña"
      />
      <Form.Button
        className="login-button"
        primary
        fluid
        type="submit"
        disabled={loading}
        loading={loading}
      >
        Entrar
      </Form.Button>
    </Form>
  );
}
